import { render, staticRenderFns } from "./diagnoseReport2v.vue?vue&type=template&id=2665fce0&scoped=true&"
import script from "./diagnoseReport2v.vue?vue&type=script&lang=js&"
export * from "./diagnoseReport2v.vue?vue&type=script&lang=js&"
import style0 from "./diagnoseReport2v.vue?vue&type=style&index=0&id=2665fce0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665fce0",
  null
  
)

export default component.exports